export const SET_USER = 'AUTH/SET_USER';
export const SET_TOKEN = 'AUTH/SET_TOKEN';
export const SET_LOADING = 'AUTH/SET_LOADING';
export const SET_ERROR = 'AUTH/SET_ERROR';
export const SET_CURRENTFORM = 'AUTH/SET_CURRENTFORM';
export const SET_CONTACTS = 'AUTH/SET_CONTACTS';
export const SET_WHATSTEXT ='AUTH/SET_WHATSTEXT';